import React, {
    useState,
} from "react";

import {
    Stack,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";

import { useDispatch } from "react-redux";

import {
    createAgentServiceAction,
    fetchAgentServicesAction,
} from "state/actions/agentServiceActions";

import {
    useCustomNotification,
} from "components/Toasts/OpenNotification";


const AddAgentService = ({
    isOpen,
    onClose,
}) => {

    const dispatch = useDispatch();

    const notify =
        useCustomNotification();


    const [
        name,
        setName,
    ] = useState("");


    const [
        description,
        setDescription,
    ] = useState("");


    const [
        isActive,
        setIsActive,
    ] = useState(true);


    const [
        submitting,
        setSubmitting,
    ] = useState(false);


    const handleSubmit =
        async () => {

            if (!name.trim()) {

                notify({
                    message:
                        "Service Name Required",

                    description:
                        "Please enter a service name.",

                    type:
                        "error",
                });

                return;
            }


            if (!description.trim()) {

                notify({
                    message:
                        "Description Required",

                    description:
                        "Please enter a service description.",

                    type:
                        "error",
                });

                return;
            }


            setSubmitting(true);


            const payload = {

                name:
                    name.trim(),

                description:
                    description.trim(),

                is_active:
                    isActive,

            };


            const response =
                await dispatch(
                    createAgentServiceAction(
                        payload
                    )
                );


            setSubmitting(false);


            if (
                response.success
            ) {

                notify({
                    message:
                        "Service Created",

                    description:
                        "Agent service created successfully.",

                    type:
                        "success",
                });


                dispatch(
                    fetchAgentServicesAction()
                );


                setName("");

                setDescription("");

                setIsActive(true);

                onClose();

            } else {

                notify({
                    message:
                        "Failed to Create Service",

                    description:
                        response.error ||
                        "Something went wrong while creating the service.",

                    type:
                        "error",
                });

            }
        };


    return (

        <ReusableDrawer

            isOpen={
                isOpen
            }

            onClose={
                onClose
            }

            headerContent={
                <h2>
                    Add Agent Service
                </h2>
            }

            bodyContent={

                <Stack
                    spacing={5}
                >

                    <ReusableInput

                        label="Service Name"

                        placeholder="Enter service name"

                        value={
                            name
                        }

                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }

                        isRequired

                    />


                    <ReusableInput

                        label="Description"

                        placeholder="Enter service description"

                        value={
                            description
                        }

                        onChange={(e) =>
                            setDescription(
                                e.target.value
                            )
                        }

                        type="textarea"

                        isRequired

                    />


                    {/* <ReusableInput

                        label="Active"

                        type="checkbox"

                        value={
                            isActive
                        }

                        onChange={(e) =>
                            setIsActive(
                                e.target.checked
                            )
                        }

                    /> */}

                </Stack>

            }

            footerContent={

                <Stack
                    direction="row"
                    spacing={4}
                    justifyContent="flex-end"
                >

                    <GradientButton
                        width="100px"
                        height="40px"
                        onClick={
                            onClose
                        }
                    >
                        Cancel
                    </GradientButton>


                    <GradientButton
                        width="120px"
                        height="40px"
                        onClick={
                            handleSubmit
                        }
                        isLoading={
                            submitting
                        }
                    >
                        Create
                    </GradientButton>

                </Stack>

            }

        />

    );
};


export default AddAgentService;